import React from 'react'
import { Box, Typography } from '@mui/material'
import { AdvancedReflection } from '../api/types'
import { advancedColors } from '../theme'
import { formatDayTime } from '../format'
import EmptyState from './EmptyState'

type Props = { reflections: AdvancedReflection[] }

// PHI: rendered as text and nothing more — never to Mixpanel, error reporting or a console log.
const ReflectionsFeed = ({ reflections }: Props) => {
  if (reflections.length === 0) {
    return <EmptyState title="No reflections yet" description="Written reflections appear here as they are saved." />
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {reflections.map((reflection) => (
        <Box
          key={reflection.reflectionId}
          sx={{
            borderLeft: `3px solid ${advancedColors.accent}`,
            backgroundColor: advancedColors.surfaceSunken,
            borderRadius: '0 8px 8px 0',
            px: 2,
            py: 1.5,
          }}
        >
          <Typography variant="subtitle2" sx={{ color: advancedColors.inkMuted, fontWeight: 600 }}>
            {reflection.prompt}
          </Typography>
          <Typography
            variant="body2"
            sx={{ mt: 0.75, color: advancedColors.ink, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}
          >
            {reflection.body}
          </Typography>
          <Typography variant="subtitle2" sx={{ mt: 1, color: advancedColors.ink }}>
            {formatDayTime(reflection.createdAt)}
          </Typography>
        </Box>
      ))}
    </Box>
  )
}

export default ReflectionsFeed
